import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../commonComponents/Buttons";

import "./videoEndModal.scss";
import { CoinIcon } from "../../../assets";

function VideoEndModal({ earnedPoint, closeModal }) {
  const { t } = useTranslation();
  return (
    <>
      <section className="modalBg">
        <section className="modalBody videoEndModal">
          <div className="dialog-header">
            <h3 className="heading-3">{t("videoEnd")}</h3>
            {earnedPoint && (
              <legend>
                {t("earnedInfo")}&nbsp;
                <img className="pointIcon" src={CoinIcon} alt={t("Points")} />
                &nbsp;1
              </legend>
            )}
          </div>

          <div className="buttons dialog-footer">
            <Button
              label={t("ok")}
              viewType="mainBtn"
              onClick={closeModal}
            />
          </div>
        </section>
      </section>
    </>
  );
}

export default VideoEndModal;
